import * as Yup from 'yup';
import { TCustomizableItemList } from '../../../components/types';

export const createCustomReportInitialValues = {
  report_name: "",
  // report_name_is_unique: true,
  fields: [] as TCustomizableItemList[],
}

// not in use - dynamic validation with API call is used
export const createCustomReportValidationSchema = Yup.object().shape({
  report_name:
    Yup.string()
      .required('Please enter a name for the report')
      .max(255, 'Maximum 255 characters'),
  fields: Yup.array().min(1, 'Please add at least one field'),
});
